import * as time from '../../app/header/time'
import * as saveToPortfolio from '../../app/quote/save-to-portfolio'
import * as button from './button'
import * as buttonGroup from './button-group'
import * as checkbox from './checkbox'
import * as colorPicker from './color-picker'
import * as contextMenu from './context-menu'
import * as copyToClipboard from './copy-to-clipboard'
import * as datePicker from './date-picker'
import * as delayed from './delayed'
import * as dialog from './dialog'
import * as dropdown from './dropdown'
import * as grid from './grid'
import * as icon from './icon'
import * as innerState from './inner-state'
import * as input from './input'
import * as list from './list'
import * as notification from './notification'
import * as popover from './popover'
import * as portfolio from './portfolio'
import * as range from './range'
import * as search from './search'
import * as select from './select'
import * as spinner from './spinner'
import * as timeframeBar from './timeframe-bar'
import * as toolbar from './toolbar'
import * as tooltip from './tooltip'
import * as tooltipInput from './tooltip-input'
import * as tour from './tour'
import * as typography from './typography'

function exportAsGlobal(win: any, key: string) {
  if (!(key in win)) win[key] = {}

  win[key].components = {
    ...button,
    ...buttonGroup,
    ...checkbox,
    ...colorPicker,
    ...contextMenu,
    ...copyToClipboard,
    ...delayed,
    ...dialog,
    ...datePicker,
    ...dropdown,
    ...grid,
    ...icon,
    ...innerState,
    ...input,
    ...list,
    ...notification,
    ...popover,
    ...range,
    ...search,
    ...select,
    ...spinner,
    ...time,
    ...timeframeBar,
    ...toolbar,
    ...tooltip,
    ...tooltipInput,
    ...tour,
    ...typography,
    ...portfolio,
    ...saveToPortfolio,
  }
}

exportAsGlobal(window, 'FLibs')
